/* eslint-disable quote-props */

import _ from 'lodash';
import { setAllPetsAsync } from './allPets';
import { setLastVerificationDate, setVerificationError } from './lastVerification';
import { setPurchaseLoading, onPurchase, checkForSkuPurchase } from './purchases';
import { PURCHASES_NOT_SUPPORTED_FOR_COUNTRY } from '../constants';
import log from '../utils/log';

import { getPurchasesResponse, getSkuDetailsResponse } from '../utils/fakeGoogle';

// --------------------------------------------------------
// Update in-app purchase data from Google.
// --------------------------------------------------------

function getPurchases() {
	return new Promise((resolve, reject) => {
		return resolve(getPurchasesResponse);

		// window.google.payments.inapp.getPurchases({
		// 	'parameters': { 'env': 'prod' },
		// 	'success': resolve,
		// 	'failure': reject,
		// });
	});
}

function getSkuDetails() {
	return new Promise((resolve, reject) => {
		return resolve(getSkuDetailsResponse);

		// window.google.payments.inapp.getSkuDetails({
		// 	'parameters': { 'env': 'prod' },
		// 	'success': resolve,
		// 	'failure': reject,
		// });
	});
}

export function updateInAppPurchaseData() {
	return (dispatch, getState) => {

		// Reformat the promise so that it reports whether
		// or not it succeeds without having to rely on .catch()
		const skuDetailsPromise = getSkuDetails()
			.then(
				data => ({ status: 'success', data }),
				data => ({ status: 'error', data }),
			);

		// Same format as described above
		const purchasesPromise = getPurchases()
			.then(
				data => ({ status: 'success', data }),
				data => ({ status: 'error', data }),
			);

		// Wait on both promises. Even if one or both fail,
		// we will get to the `then` block and we can check what
		// the `status` of each was to determine what to do next.
		Promise.all([
			purchasesPromise,
			skuDetailsPromise,
		])
		.then(([purchasesResponse, skuDetailsResponse]) => {
			// Since this is fake data from a fake API call,
			// we know it succeeded and we can move on.
			setAllPetsAsync(skuDetailsResponse.data, purchasesResponse.data, dispatch, getState);
			dispatch(setLastVerificationDate());

			// Here's the old error handling mechanism

			// Whether or not these API calls succeeded, we'll be here.
			// There are three possible scenarios:
			// 	1. the user is logged into chrome and the responses worked
			// 	2. the user is NOT logged in and both calls failed with TOKEN_MISSING_ERROR
			// 	3. an actual error
			// We can look at the `status` and response objects to decide which of
			// these happened.

			// log('initialize -> updateInAppPurchaseData: ', { purchasesResponse, skuDetailsResponse });

			// if (purchasesResponse.status === 'error' || skuDetailsResponse.status === 'error') {
			// 	// One or both of these errored. First thing we'll check is
			// 	// whether we've reached the LOGGED_THE_HECK_OUT case where
			// 	// both API calls returned TOKEN_MISSING_ERROR.
			// 	if (
			// 		_.get(purchasesResponse, 'data.response.errorType') === 'TOKEN_MISSING_ERROR' &&
			// 		_.get(skuDetailsResponse, 'data.response.errorType') === 'TOKEN_MISSING_ERROR'
			// 	) {
			// 		// The user is not logged into chrome. We can show the cached
			// 		// products here and the rest will be up to them to initiate,
			// 		// if they decide they want to purchase something.
			// 		log('The user is not logged in');
			// 		setAllPetsAsync(null, null, dispatch, getState);
			// 		dispatch(setLastVerificationDate());

			// 	} else if (
			// 		_.get(purchasesResponse, 'data.response.errorType') === 'INVALID_RESPONSE_ERROR' &&
			// 		_.get(skuDetailsResponse, 'data.response.errorType') === 'INVALID_RESPONSE_ERROR' &&
			// 		getState().allPets.length === 1 // The user has never reached the API so they only have Tabby Cat
			// 	) {
			// 		// The user is in a country where payments aren't supported.
			// 		// Dispatch this error so that the PetPicker is hidden.
			// 		console.error('Purchases are not supported in this country.');
			// 		dispatch(setVerificationError(PURCHASES_NOT_SUPPORTED_FOR_COUNTRY));

			// 	} else {
			// 		// An error occurred! (#3 in the list above)
			// 		// Let's leave a bit of info in the console...
			// 		console.error('One or both API calls failed. Responses:');
			// 		console.error(skuDetailsResponse, purchasesResponse);
			// 		// ...and since we want to know what happened but don't
			// 		// know which error is meaningful...
			// 		const errorTypes = [
			// 			_.get(purchasesResponse, 'data.response.errorType', 'GET_PURCHASES_SUCCEEDED'),
			// 			_.get(skuDetailsResponse, 'data.response.errorType', 'GET_SKU_DETAILS_SUCCEEDED'),
			// 		];
			// 		// ...join them together with a plus sign.
			// 		dispatch(setVerificationError({
			// 			response: {
			// 				errorType: errorTypes.join(' + '),
			// 			},
			// 		}));
			// 	}
			// } else {
			// 	// It all worked! Let's set the data and move on.
			// 	setAllPetsAsync(skuDetailsResponse.data, purchasesResponse.data, dispatch, getState);
			// 	dispatch(setLastVerificationDate());
			// }
		})
		.catch((err) => {
			// Now if we hit this catch it's probably the result of a JS error.
			// Logging it to the console as a last resort.
			console.error(err);
		});
	};
}


// --------------------------------------------------------
// Buy a pet.
// --------------------------------------------------------

function buy(sku) {
	return new Promise((resolve, reject) => {
		log('buy promise sku: ', sku);
		window.google.payments.inapp.buy({
			'parameters': { 'env': 'prod' },
			'sku': sku,
			'success': resolve,
			'failure': reject,
		});
	});
}

// DEVELOPMENT ONLY
// function getPurchasesAfterBuy() {
// 	log('getting purchases');
// 	return new Promise((resolve, reject) => {
// 		window.google.payments.inapp.getPurchasesAfterBuy({
// 			'parameters': { 'env': 'prod' },
// 			'success': resolve,
// 			'failure': reject,
// 		});
// 	});
// }

export function buyPet(sku) {
	return (dispatch) => {
		log('This should never happen!');
		return;

		log(`buy pet: ${sku}`);
		dispatch(setPurchaseLoading(sku, true));

		buy(sku)
			.then((buyResponse) => {
				log('buy success: ', buyResponse);
				// return getPurchasesAfterBuy() // DEVELOPMENT ONLY
				// return getPurchases() // GET PURCHASES DOESNT WORK
				// 	.then((purchaseResponse) => {
				// 		onPurchase(sku, purchaseResponse, dispatch);
				// 		log('getPurchases success: ', purchaseResponse);
				// 	})
				// 	.catch((purchaseErr) => {
				// 		dispatch(setVerificationError(purchaseErr));
				// 		dispatch(setPurchaseLoading(sku, false));
				// 		console.error('getPurchases error after buy responded successfully: ', purchaseErr);
				// 	});
				onPurchase(sku, buyResponse, dispatch);
			})
			.catch((buyResponse) => {
				console.error('buy error with response: ', buyResponse);
				// return getPurchasesAfterBuy() // DEVELOPMENT ONLY
				getPurchases()
					.then((purchasesResponse) => {
						log('after buy -> getPurchases: ', purchasesResponse);

						let isGoogleLyingCount = 0;

						function isGoogleLying() {
							setTimeout(() => {
								const itemWasPurchasedSuccessfully = checkForSkuPurchase(sku, purchasesResponse);
								isGoogleLyingCount++;

								log(`after buy -> getPurchases -> itemWasPurchasedSuccessfully ${isGoogleLyingCount}: `, itemWasPurchasedSuccessfully);

								if (itemWasPurchasedSuccessfully) {
									onPurchase(sku, buyResponse, dispatch, { forceSuccess: true });
								} else {
									if (isGoogleLyingCount > 3) {
										log('We checked for the purchase 4 times and it didn’t come back :(');
										onPurchase(sku, buyResponse, dispatch);
										return;
									}
									isGoogleLying();
								}
							}, 500);
						}

						isGoogleLying();
					})
					.catch((purchaseErr) => {
						console.error('getPurchases error after buy responded with an error: ', purchaseErr);
						onPurchase(sku, buyResponse, dispatch);
					});
			});
	};
}



// WEBPACK FOOTER //
// ./src/actions/googleApi.js